/**
 * @generated SignedSource<<0f1790b1e769fe3182c2fe3e37ab6bd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SettingsProfileSubNav_viewer$data = {
  readonly id: string;
  readonly projectOwner: boolean | null;
  readonly disableNotifications: boolean | null;
  readonly company: {
    readonly id: string;
    readonly forecastDemo: boolean | null;
    readonly tier: TierType | null;
  } | null;
  readonly " $fragmentType": "SettingsProfileSubNav_viewer";
};
export type SettingsProfileSubNav_viewer$key = {
  readonly " $data"?: SettingsProfileSubNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsProfileSubNav_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsProfileSubNav_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a8c5a706e6644304f251dfa33004b1cd";

export default node;
